import React, { useState, useEffect, useContext } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { api } from '../../services/api';
import { Box, Typography } from '@mui/material'
import { externalComponent } from '../AppRoutes';
import { IOSSwitch } from '../Utils/switch';


const changeQuerySwitch = async (value,setter,setLoader) => {

    let param = null
    if(!value === false){
        param = 0
    }
    else{
        param = 1
    }
        
    
    const body = {
        value: !value
    }
    setLoader(true)
        const res = await api.post('/configuracoes_query/', body, {timeout: 1000})
    setLoader(false)
    if (res.status === 200) {
        setter(!value)
        return
    }
}

const consultQueryValue = async (setLoader,setter) => {

    setLoader(true)
        const res = await api.get('/configuracoes_query/', {timeout: 1000})
    setLoader(false)
    if (res.status === 200) {
        setter(res.data)
        return
    }

}

const ConfiguracoesToggle = () => {

    const [querySwitch, setQuerySwitch] = useState(false)

    const { setLoader } = useContext(externalComponent)


    useEffect(()=>{
        consultQueryValue(setLoader,setQuerySwitch)
    }, [])
    

  return (
    <Box>
        <Typography>Queries do sistema</Typography>
        <FormGroup>
        <FormControlLabel
            control={<IOSSwitch sx={{ m: 1 }} checked={querySwitch} onChange={()=> changeQuerySwitch(querySwitch,setQuerySwitch,setLoader)} />}
            label={querySwitch ? 'Alterada' : 'Normal'}
        />
        </FormGroup>
    </Box>
  );
}


export default ConfiguracoesToggle;
